import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=5f24b534&"
import script from "./Scan.vue?vue&type=script&lang=ts&"
export * from "./Scan.vue?vue&type=script&lang=ts&"
import style0 from "vue-phone-number-input/dist/vue-phone-number-input.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports